import React from 'react';
import SingleBetItem from './SingleBetItem';

interface SingleBetListProps {
  id: string;
  onDelete: (id: string) => void;
  type: string;
}

const SingleBetList: React.FunctionComponent<SingleBetListProps> = ({ id, onDelete, type }) => {
  return (
    <div className="single-bet">
      <SingleBetItem id={id} onDelete={() => onDelete(id)} type={type} />
    </div>
  );
};

export default SingleBetList;
